import { lazy } from 'react';

const SpecialOffersRoutes = [
  {
    path: 'special-offers/add',
    component: lazy(() => import('views/special-offers/special-offer-add')),
  },
  {
    path: 'special-offers/:id',
    component: lazy(() => import('views/special-offers/special-offer-edit')),
  },
  {
    path: 'special-offers',
    component: lazy(() => import('views/special-offers')),
  },
];

export default SpecialOffersRoutes;
